import { useEffect, useRef } from 'react';

// Derive SSE base URL from the same env var used by axios
const API_BASE = process.env.REACT_APP_API_URL || '/api';
const SSE_URL = API_BASE + '/admin/events';

export function useAdminEvents(onEvent) {
  const onEventRef = useRef(onEvent);
  useEffect(() => { onEventRef.current = onEvent; }, [onEvent]);

  useEffect(() => {
    let es = null;
    let retryTimer = null;

    const connect = () => {
      es = new EventSource(SSE_URL, { withCredentials: true });

      es.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          if (data.type !== 'connected') onEventRef.current(data);
        } catch (_) {}
      };

      es.onerror = () => {
        es.close();
        // Reconnect after 8s if the connection drops
        retryTimer = setTimeout(connect, 8000);
      };
    };

    connect();

    return () => {
      clearTimeout(retryTimer);
      if (es) es.close();
    };
  }, []); // only once on mount
}
